import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.$style.result)
  }, [
    ($props.matches)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createVNode($setup["Check"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createElementVNode("h2", {
        class: _normalizeClass(_ctx.$style.title)
      }, _toDisplayString($setup.content), 3),
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.description)
      }, [
        ($props.matches)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Exact match"))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString($props.matches ? ', ' : '') + "#" + _toDisplayString($setup.id), 1)
      ], 2)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.$style.added)
      }, _toDisplayString($setup.timeAgo), 3),
      _createElementVNode("button", {
        class: _normalizeClass(["delete", _ctx.$style.delete]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete', $setup.id)))
      }, [
        _createVNode($setup["Trash"])
      ], 2)
    ])
  ], 2))
}